import '@/App.scoped.scss';
// import { useTranslation } from 'react-i18next';
import Header from 'src/components/Header';
import Footer from 'src/components/Footer';
import Router from './Router';
import { AppContextProvider } from 'src/AppContext';
import UserContainer from './containers/UserContainer';
import { UserContextProvider } from './UserContext';
import { ModalContextProvider } from './ModalContext';
import { TermsContextProvider } from './TermsContext';

function App(): JSX.Element {
  return (
    <>
      <UserContextProvider>
        <ModalContextProvider>
          <TermsContextProvider>
            <AppContextProvider>
              <UserContainer />
              <Header />
              <Router />
              <Footer />
            </AppContextProvider>
          </TermsContextProvider>
        </ModalContextProvider>
      </UserContextProvider>
    </>
  );
}

export default App;
